import { store } from '../stores/mainStore';
import { Integration } from './Integration';
//import { comm } from '../comm';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA16TVa4skTj7ci8RbiMXog3nwZ9DCuNOE",
  authDomain: "skillz-version-web-trial.firebaseapp.com",
  projectId: "skillz-version-web-trial",
  storageBucket: "skillz-version-web-trial.appspot.com",
  messagingSenderId: "295363429914",
  appId: "1:295363429914:web:aa78998eeb2fa1a495b3a3",
  measurementId: "G-BJ8T48R3MX"
};

export class StandAlone extends Integration {
	PlatformId = 'sa';
	analytics = null;

	constructor() {
		super();
		window.addEventListener('message', this.processMessage, false);
		
		// Initialize Firebase
		const app = initializeApp(firebaseConfig);
		
		require('firebase/analytics')
		this.analytics = app.analytics();	
		this.postEvent('init_firebase', 'loading')
	}
	postEvent(label, category = '', value = 'none', onlyOnce = false) {
		if(onlyOnce === true) {
			if (localStorage.getItem(label+'_event_sent'))
				return;
			else 
				window.setPersistentStorage(label+'_event_sent', 'true');
		}

		const eventParams = {
			event_label: label,
			event_category: category && category !== '' ? category : 
				store.tutorialMode ? 'tutorial' : 'gameplay',
			value: typeof value === 'number' || (typeof value === 'string' && value !== 'none') ? value : Date.now().toString()
		}
		console.log('EVT ---> firebase event ::', eventParams)
		this.analytics.logEvent(label, eventParams);
	}

	initAnalytics(uid) {}

	postAnalyticsEvent(label, category = '', value = 'none') { 
		console.log(' EVT V1', label, value)
	}
	postAnalyticsEvent_v2(label, category = '', value = 'none', alsoGA = false, alsoAF = false, onlyOnce = false, alsoFBK = false) {
		console.log(' EVT V2', label, value)
	}
	postAnalyticsEvent_v3(label, category = '', value = 'none', alsoGA = false, alsoAF = false, onlyOnce = false, alsoFBK = false) {
		console.log(' EVT V3', label, value)
	}

	setAnalyticsUserId(userId) {
		window.WrapperApp.postMessage('guest-userid?userid=' + userId);
	}

	get tutorialWager() {
		return store.user.lastBetAmount;
	}
	get tutorialPayout() {
		return store.tutorialPayout;
	}
	processMessage = (msg) => {};
}
